import { ReactNode } from 'react'

import Footer from 'src/components/ui/atoms/Footer'
import useHasFooter from 'src/hooks/layout/useHasFooter'
import usePrinter from 'src/hooks/usePrinter'
import { cn } from 'src/lib/cn'
import useSidebarStore from 'src/stores/useSidebarStore'
import Sidebar from '../../organisms/Sidebar'

import * as styles from './Layout.scss'

interface Props {
  children: ReactNode
}

const Layout = ({ children }: Props) => {
  const { printMode } = usePrinter()
  const isMenuOpen = useSidebarStore(s => s.isOpen || s.searchInputFocusedId !== null)
  const hasFooter = useHasFooter()

  return (
    <div
      className={cn(
        styles.App,
        {
          [styles.AppPrintMode]: printMode,
        },
        !hasFooter && 'min-w-xl!',
      )}
    >
      <main className={styles.Content}>
        <Sidebar />
        <div
          className={cn(styles.RightPanel, {
            [styles.RightPanelMenuOpen]: isMenuOpen,
            [styles.RightPanelPrintMode]: printMode,
          })}
        >
          <div className={styles.RouteContent} id="content">
            <div
              className={cn(
                styles.ContentWithoutFooter,
                {
                  [styles.ContentWithoutFooterPrintMode]: printMode,
                },
                !hasFooter && 'pb-4!',
              )}
            >
              {children}
            </div>
            {hasFooter && <Footer />}
          </div>
        </div>
      </main>
    </div>
  )
}

export default Layout
